/* eslint-disable react/display-name */
import VALIDATION_ERRORS from '@/constants/validationErrors';
import React, { useCallback } from 'react';
import { FieldError } from 'react-hook-form';
import Checkbox from './crisp/Checkbox';
import Div from './Div';
import classNames from 'classnames';
import Map from '@/components/Map';
import Paragraph from './Paragraph';

const MultiCheckboxInput = React.forwardRef(
  ({ options = [], value = [], errors, name, onChange, ...restProps }: any, ref) => {
    const fieldError: FieldError | undefined = (errors?.[name] as FieldError) ?? undefined;
    const errorMessage = fieldError?.message || VALIDATION_ERRORS[fieldError?.type];

    const handleCheckboxChange = (checked: boolean, option: { id: string; label: string }) => {
      let newValue;
      if (checked) {
        newValue = [...value, option];
      } else {
        newValue = value.filter((val: { id: string }) => val.id !== option.id);
      }
      onChange(newValue);
    };

    const renderLabel = useCallback(
      (item: any) => (
        <Paragraph className=" text-body-lg w-full text-cti-primary">{item.label}</Paragraph>
      ),
      [],
    );

    const renderCheckBoxInput = useCallback(
      (item: { label: string; id: string }, index: number) => {
        const isSelected = Boolean(
          value.find((selectedItem: { id: string }) => selectedItem.id === item.id),
        );

        return (
          <Checkbox
            name={item.id}
            key={index}
            id={item.id}
            checked={isSelected}
            className={classNames('flex pl-s1 pr-s4 py-s5 border rounded-cm gap-s3', {
              'border-solid border-blue-400 bg-blue-50': isSelected,
            })}
            onChange={(e) => handleCheckboxChange(e.target.checked, item)}
            render={() => renderLabel(item)}
          />
        );
      },
      [value, options],
    );
    return (
      <>
        <Map
          list={options}
          className="flex flex-col md:flex-row gap-s5 md:flex-wrap md:mb-s3"
          render={renderCheckBoxInput}
        />
        <Div
          forceRender
          className={classNames('text-body-base text-neutral-700', {
            'text-red-500': errorMessage,
          })}
        >
          {errorMessage}
        </Div>
      </>
    );
  },
);

export default MultiCheckboxInput;
